/*
 * @Description: '结局方案'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2021-09-09 15:23:30
*/

export default [
  {
    path: 'solution',
    component: resolve => require(['@/views/solution'], resolve),
    name: 'Solution',
    meta: {
      title: '解决方案'
    }
  },
  {
    path: 'solution/:id',
    component: resolve => require(['@/views/solution/detail'], resolve),
    name: 'SolutionDetail',
    meta: {
      title: '解决方案'
    }
  }
      
]


// WEBPACK FOOTER //
// ./src/router/solution.js